import { POPULAR_TAB } from '../../helpers';

export const isPopularTab = (category: string) => category === POPULAR_TAB;
